// ─── Types ────────────────────────────────────────────────────────────────────

/** La sesión guardada en `localStorage`, tal como la ve un refresco del perfil. */
export interface StoredProfileSession {
  corporateId: string | null;
  /** JWT de la sesión: dos admins del mismo panel tienen el mismo `corporateId`. */
  token: string | null;
  /** Sección guardada por el menú (`setLocalRoute`); `null` si no hay. */
  route: string | null;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

/** Lee la sesión de `storage`. Un `dataLogin` ilegible cuenta como sin sesión. */
export const readStoredProfileSession = (
  storage: Pick<Storage, 'getItem'>,
): StoredProfileSession => {
  const token = storage.getItem('token');
  try {
    const dataLogin = JSON.parse(storage.getItem('dataLogin') ?? 'null');
    return {
      corporateId: dataLogin?.corporate_id ?? null,
      token,
      route: dataLogin?.route ?? null,
    };
  } catch {
    return { corporateId: null, token, route: null };
  }
};

/**
 * Si una respuesta de `get-profile` todavía es de la sesión que la pidió. Se
 * compara la sesión guardada al pedir con la guardada al llegar: si cambió el
 * panel (cambio de panel), el token (otro admin del mismo panel) o se borró
 * (logout), la respuesta es de otra sesión y se descarta. Sin sesión al pedir y
 * al recibir se aplica, como antes.
 */
export const shouldApplyProfileResponse = (
  requested: Pick<StoredProfileSession, 'corporateId' | 'token'>,
  current: Pick<StoredProfileSession, 'corporateId' | 'token'>,
): boolean =>
  requested.corporateId === current.corporateId &&
  requested.token === current.token;
